import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Switch from 'britive-design-system/core/components/switch'
import Checkbox from 'britive-design-system/core/components/checkbox'
import { Col, Row } from 'reactstrap'
import { getSelectedApplicationRoot } from 'selectors/application_root'
import { isEmpty } from 'lodash'

const CredentialType = ({
  credentialType,
  handleToggle,
  editAdditionalSettings,
  onCheckStateChange,
  papAdditionalSettings,
}) => {
  const applicationRoot = useSelector(getSelectedApplicationRoot)

  useEffect(() => {
    if (!papAdditionalSettings || isEmpty(papAdditionalSettings)) return
    const hasKey =
      papAdditionalSettings &&
      'useApplicationCredentialType' in papAdditionalSettings
    if (papAdditionalSettings?.useApplicationCredentialType || !hasKey) {
      usedApplicationSettings()
    } else {
      onCheckStateChange({
        useApplicationCredentialType:
          papAdditionalSettings?.useApplicationCredentialType || false,
        consoleAccess: papAdditionalSettings?.consoleAccess || false,
        programmaticAccess: papAdditionalSettings?.programmaticAccess || false,
      })
    }
  }, [papAdditionalSettings])

  useEffect(() => {
    if (credentialType?.useApplicationCredentialType) {
      usedApplicationSettings()
    }
  }, [credentialType?.useApplicationCredentialType])

  const usedApplicationSettings = () => {
    const consoleAccessItem =
      applicationRoot?.catalogApplication?.propertyTypes.find(
        item => item.name === 'consoleAccess'
      )?.value ?? false

    const programmaticAccessItem =
      applicationRoot?.catalogApplication?.propertyTypes.find(
        item => item.name === 'programmaticAccess'
      )?.value ?? false

    onCheckStateChange({
      useApplicationCredentialType: true,
      consoleAccess: consoleAccessItem,
      programmaticAccess: programmaticAccessItem,
    })
  }

  const isDisabled =
    !editAdditionalSettings || credentialType?.useApplicationCredentialType

  const handleCheckboxChange = type => e => {
    onCheckStateChange({ ...credentialType, [type]: e.target.checked })
  }

  return (
    <>
      <Col md={12}>
        <strong>Credential Type</strong>
      </Col>
      <Col md={12}>
        <Row style={{ marginTop: '16px' }}>
          <Col md={12}>
            <Switch
              label="Use Application Settings"
              checked={credentialType?.useApplicationCredentialType || false}
              onToggle={handleToggle}
              disabled={!editAdditionalSettings}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '16px' }}>
          <Col md={12}>
            <Checkbox
              label="Console Access"
              checked={credentialType.consoleAccess}
              onChange={handleCheckboxChange('consoleAccess')}
              disabled={isDisabled}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '16px' }}>
          <Col md={12}>
            <Checkbox
              label="Programmatic Access"
              checked={credentialType.programmaticAccess}
              onChange={handleCheckboxChange('programmaticAccess')}
              disabled={isDisabled}
            />
          </Col>
        </Row>
      </Col>
    </>
  )
}

export default CredentialType
